<template>
  <md-card style="max-height: 690px;">
    <md-card-header class="md-card-header-text md-card-header-green">
      <div class="card-text">
        <h4 class="title">Other Documents</h4>
        <p class="category">Student Other Documents</p>
      </div>
    </md-card-header>

    <md-card-content class="md-size-50 mx-auto" v-if="table_spinner">
      <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
    </md-card-content>
    <md-card-content style="overflow: auto; padding-top:0px">
      <md-table
        v-show="!table_spinner"
        v-model="other_files"
        table-header-color="green"
      >
        <md-table-empty-state
          md-label="No file found"
          :md-description="`No file found for this student.`"
        >
        </md-table-empty-state>
        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell md-label="Type">{{ item.type }}</md-table-cell>
          <md-table-cell md-label="Action" style="width: 20%">
            <md-button
              class="md-just-icon md-primary md-round md-layout-item md-size-10 md-label-on-right"
              :href="item.file"
              target="_blank"
              style="margin-right: 5px"
            >
              <md-icon>cloud_download</md-icon>
              <md-tooltip md-direction="bottom">Download</md-tooltip>
            </md-button>
            <md-button
              class="md-just-icon md-danger md-round"
              @click.native="handleDelete(item)"
            >
              <md-icon>close</md-icon>
              <md-tooltip md-direction="bottom">Delete</md-tooltip>
            </md-button>
          </md-table-cell>
        </md-table-row>
      </md-table>
    </md-card-content>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(addOtherFile)">
        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <h5 class="info-text">Add Other File</h5>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-50">
              <ValidationProvider
                name="type"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>Type</label>
                  <md-select v-model="type" name="type">
                    <md-option value="">Select Type</md-option>
                    <md-option value="5">Passport translation</md-option>
                    <md-option value="6">Certificate</md-option>
                    <md-option value="7"
                      >Certificate translation Turkish or English</md-option
                    >
                    <md-option value="8">Full Transcript</md-option>
                    <md-option value="9">Transcript translation</md-option>
                    <md-option value="10">GMAT Exam score</md-option>
                    <md-option value="11">SAT Exam score</md-option>
                    <md-option value="12">PTE Exam score</md-option>
                    <md-option value="13">GRE Exam score</md-option>
                    <md-option value="14">TOEFL Exam score</md-option>
                    <md-option value="15">IELTS Exam score</md-option>
                    <md-option value="16">CAE Exam score</md-option>
                    <md-option value="17">GCE A Level</md-option>
                    <md-option value="18">CPE Exam score</md-option>
                    <md-option value="19">CTE Exam score</md-option>
                    <md-option value="20">Reference</md-option>
                    <md-option value="21"
                      >Statement of purpose (motivation letter)</md-option
                    >
                    <md-option value="22"
                      >Turkish language certificate</md-option
                    >
                    <md-option value="23">YOS Exam</md-option>
                    <md-option value="24"
                      >Payment for state University</md-option
                    >
                    <md-option value="4">Other</md-option>
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>
            <div class="md-layout-item">
              <ValidationProvider
                name="file"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>File</label>
                  <md-file
                    v-model="custom_file"
                    name="file"
                    @change="onFileChange"
                  />

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>
          </div>
        </md-card-content>

        <md-card-content>
          <div class="md-layout-item md-size-100 text-right">
            <md-button
              type="submit"
              :disabled="file_disable === true"
              class="md-raised md-success mt-4 md-size-50 mx-auto"
            >
              Add other file
            </md-button>
          </div>
        </md-card-content>
      </form>
    </ValidationObserver>
  </md-card>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import Swal from "sweetalert2";
import { extend } from "vee-validate";
import { required, numeric } from "vee-validate/dist/rules";

extend("required", required);
extend("numeric", numeric);

export default {
  components: {
    SlideYDownTransition
  },
  props: {
    headerColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      userID: null,
      other_files: [],
      table_spinner: true,
      file_disable: false,

      custom_file: null,
      type: null,
      file: null
    };
  },
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    handleDelete(item) {
      Swal.fire({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteRow(item);
        }
      });
    },
    deleteRow(item) {
      this.$store
        .deleteUserOtherFile(this.userID, item.id)
        .then(response => {
          this.getUserOtherFiles();
          this.$notify({
            message: "Removed other file.",
            icon: "add_alert",
            type: "success",
            verticalAlign: "top",
            timeout: 3000
          });
        })
        .catch(error => {
          var message = error.response.data;
          this.$notify({
            message: JSON.stringify(message),
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top",
            timeout: 3000
          });
        });
    },
    addOtherFile() {
      this.file_disable = true;
      this.$store
        .addUserOtherFile(this.userID, this.file, this.type)
        .then(response => {
          this.getUserOtherFiles();
          this.file = null;
          this.custom_file = null;
          this.$notify({
            message: "Added other file.",
            icon: "add_alert",
            type: "success",
            verticalAlign: "top",
            timeout: 3000
          });
          this.file_disable = false;
        })
        .catch(error => {
          this.file_disable = false;
          var message = error.response.data;
          this.$notify({
            message: JSON.stringify(message),
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top",
            timeout: 3000
          });
        });
    },
    onFileChange(e) {
      this.file = e.target.files[0] || e.dataTransfer.files[0];
    },
    getUserOtherFiles() {
      this.$store
        .getUserOtherFiles(this.userID)
        .then(response => {
          this.other_files = response.data;
          this.table_spinner = false;
        })
        .catch(error => {
          this.table_spinner = false;
          this.$notify({
            message: error.message,
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top"
          });
        });
    }
  },
  mounted() {
    this.userID = this.$route.params.id;
    this.getUserOtherFiles();
  }
};
</script>
<style></style>
